import { render } from "./BaseBack.vue?vue&type=template&id=efdd40fe"
import script from "./BaseBack.vue?vue&type=script&lang=ts"
export * from "./BaseBack.vue?vue&type=script&lang=ts"

import "./BaseBack.vue?vue&type=style&index=0&id=efdd40fe&lang=scss"
script.render = render

export default script